import type { TOC } from '@ember/component/template-only';
import { or } from 'ember-truth-helpers';
import SettingsCentralMappingDropdownsDropdownCostProfile from 'lumen/components/settings/central-mapping/dropdowns/dropdown-cost-profile';
import { TRIGGER_CENTRAL_MAPPING_VARIANTS } from 'lumen/components/settings/central-mapping/dropdowns/triggers/trigger-central-mapping';
import type {
  CentralMappingMappingEntryChannel,
  CostSettingProfile,
} from 'lumen/models';

interface HotelSettingsCentralMappingTablesCellsTdCostProfileSignature {
  Args: {
    column: {
      costProfiles: CostSettingProfile[];
      isReadOnly?: boolean;
      onNavigateToCostSettings?: () => void;
    };
    row: {
      mappingEntry: CentralMappingMappingEntryChannel;
      setCostProfile: (costProfile: CostSettingProfile | null) => void;
    };
    rowMeta: {
      isSelected: boolean;
    };
  };
}

const HotelSettingsCentralMappingTablesCellsTdCostProfile: TOC<HotelSettingsCentralMappingTablesCellsTdCostProfileSignature> =
  <template>
    <div data-test-id="table-central-mapping-td-cost-profile">
      <SettingsCentralMappingDropdownsDropdownCostProfile
        @autoCostProfile={{@row.mappingEntry.autoCostProfile}}
        @costProfile={{@row.mappingEntry.costProfile}}
        @isReadOnly={{or @column.isReadOnly @rowMeta.isSelected}}
        @isSelected={{@rowMeta.isSelected}}
        @onNavigateToCostSettings={{@column.onNavigateToCostSettings}}
        @profiles={{@column.costProfiles}}
        @setCostProfile={{@row.setCostProfile}}
        @userCostProfile={{@row.mappingEntry.userCostProfile}}
        @variant={{TRIGGER_CENTRAL_MAPPING_VARIANTS.SUBDUED}}
      />
    </div>
  </template>;

export default HotelSettingsCentralMappingTablesCellsTdCostProfile;
